var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2069 8.24138C1.54035 8.24138 1 7.70103 1 7.03448V2.37931C1 1.61754 1.61754 1 2.37931 1H7.03448C7.70103 1 8.24138 1.54035 8.24138 2.2069M5.13793 11H9.62069C10.3825 11 11 10.3825 11 9.62069V5.13793C11 4.37616 10.3825 3.75862 9.62069 3.75862H5.13793C4.37616 3.75862 3.75862 4.37616 3.75862 5.13793V9.62069C3.75862 10.3825 4.37616 11 5.13793 11Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.018a6ecf10dc5f515fb159f53cc258a6.svg";
export { ForwardRef as ReactComponent };